export default "__VITE_ASSET__BYyVdiBi__"